import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  IonItem,
  IonList,
  IonSelect,
  IonSelectOption,
  IonToggle,
} from '@ionic/angular';
import { TranslocoDirective } from '@jsverse/transloco';
import { FontSizePreference, ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-accessibility-settings',
  imports: [
    IonList,
    IonItem,
    IonToggle,
    IonSelect,
    IonSelectOption,
    TranslocoDirective,
  ],
  templateUrl: './accessibility-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessibilitySettingsComponent {
  readonly themeService = inject(ThemeService);

  onDarkModeChange(event: CustomEvent): void {
    void this.themeService.setDarkMode(event.detail.checked);
  }

  onHighContrastChange(event: CustomEvent): void {
    void this.themeService.setHighContrast(event.detail.checked);
  }

  onReducedMotionChange(event: CustomEvent): void {
    void this.themeService.setReducedMotion(event.detail.checked);
  }

  onFontSizeChange(event: CustomEvent): void {
    void this.themeService.setFontSize(event.detail.value as FontSizePreference);
  }
}
